import { stopPlayingYoutube, youtubeSrc } from '../../src/js/youtube';

export default function mediaRow () {
	document.querySelectorAll('.media-row').forEach(bind);
}

function bind (section) {
	section.querySelectorAll('.item.is-video').forEach((item) => {
		const play = item.querySelector('.play');
		if (! play || play.dataset.bound) return;
		play.dataset.bound = '1';
		play.addEventListener('click', () => activate (item));
	});
}

function releaseCursor (item) {
	item.removeAttribute('data-cursor');
	const cursor = document.querySelector('.site-cursor');
	if (! cursor) return;
	cursor.classList.remove('is-play');
	if (item.querySelector('iframe')) cursor.classList.remove('is-on');
}

function activate (item) {
	if (item.classList.contains('is-playing')) return;
	item.classList.add('is-playing');
	item.removeAttribute('data-cursor');

	if (item.dataset.source === 'youtube' && item.dataset.youtube) {
		stopPlayingYoutube();
		const frame = document.createElement('iframe');
		frame.className = 'frame';
		frame.src = youtubeSrc(item.dataset.youtube);
		frame.title = 'Video';
		frame.allow = 'autoplay; encrypted-media; picture-in-picture';
		frame.allowFullscreen = true;
		item.replaceChildren(frame);
		releaseCursor(item);
		return;
	}

	let video = item.querySelector('video');
	if (! video) {
		video = document.createElement('video');
		video.className = 'file';
		video.playsInline = true;
		video.preload = 'auto';
		video.setAttribute('playsinline', '');
		const source = document.createElement('source');
		source.src = item.dataset.src || '';
		source.type = item.dataset.mime || 'video/mp4';
		video.append(source);
	}
	video.hidden = false;
	video.controls = true;
	video.muted = false;
	item.replaceChildren(video);
	releaseCursor(item);
	const pending = video.play();
	if (pending && typeof pending.catch === 'function') pending.catch(() => {});
}
